export default __webpack_public_path__ + "static/tvd-77fc1c85b40d9c8a2841ea463e7bc1db.jpg";